import { pricerColumnsData } from "helpers/Pricer/utils";

/** String keys only — avoids reading FIELD_NAMES while pricerTable is still initializing (utils ↔ pricerTable cycle). */
const HIDDEN_PAYOUT_FIELDS = new Set([
  "id",
  "summary_reference_id",
  "leg_reference_id",
  "copy_shorthand",
  "copy_shorthand_without_vol",
  "copy_shorthand_without_vol_prem",
  "copy_shorthand_legs",
  "summary_agg",
  "leg_agg",
  "rowColor",
]);

/** Last pricing column (inclusive) — matches main pricer layout per role. */
const PAYOUT_LAST_COLUMN_FIELD_NON_TRADER = "ask_quantity";
const PAYOUT_LAST_COLUMN_FIELD_TRADER = "bid";

function getPayoutLastColumnField(notTrader) {
  return notTrader
    ? PAYOUT_LAST_COLUMN_FIELD_NON_TRADER
    : PAYOUT_LAST_COLUMN_FIELD_TRADER;
}

/** Same column defs as the main pricer grid (role-based visibility included). */
export function buildPayoutOptionColumnDefs({
  darkTheme,
  editable,
  rowEditingData,
  notTrader,
  secondaryCompaniesEstColumns = [],
  estColumns,
}) {
  const defs = pricerColumnsData(
    darkTheme,
    editable,
    rowEditingData,
    secondaryCompaniesEstColumns,
    notTrader,
    estColumns
  );

  return applyPayoutAgGridColumnDefs(defs, {
    lastColumnField: getPayoutLastColumnField(notTrader),
  });
}

function isPayoutStructuralColumn(col) {
  if (col.rowGroup) return true;
  if (col.field && HIDDEN_PAYOUT_FIELDS.has(col.field)) return true;
  return false;
}

const PAYOUT_EXCLUDED_DISPLAY_FIELDS = new Set([
  "is_auto_update_vol",
  "actions",
]);

function isPayoutDisplayColumn(col) {
  if (isPayoutStructuralColumn(col)) return false;
  if (col.field && PAYOUT_EXCLUDED_DISPLAY_FIELDS.has(col.field)) return false;
  if (col.headerCheckboxSelection || col.checkboxSelection) return true;
  if (col.hide) return false;
  return !!(col.field || col.colId);
}

export function getVisiblePayoutOptionColumns(
  columnDefs,
  lastColumnField = PAYOUT_LAST_COLUMN_FIELD_NON_TRADER
) {
  const visible = columnDefs.filter(isPayoutDisplayColumn);

  const lastIndex = visible.findIndex((col) => col.field === lastColumnField);
  if (lastIndex < 0) return visible;

  return visible.slice(0, lastIndex + 1);
}

/** Hide columns after the role-specific last pricing column. */
export function applyPayoutAgGridColumnDefs(
  columnDefs,
  { lastColumnField = PAYOUT_LAST_COLUMN_FIELD_NON_TRADER } = {}
) {
  const visibleKeys = new Set(
    getVisiblePayoutOptionColumns(columnDefs, lastColumnField).map(
      (col) => col.colId ?? col.field ?? ""
    )
  );

  return columnDefs.map((col) => {
    if (isPayoutStructuralColumn(col)) return col;

    const key = col.colId ?? col.field ?? "";
    const shouldShow =
      col.headerCheckboxSelection ||
      col.checkboxSelection ||
      visibleKeys.has(key);

    const withoutColumnMenu = {
      suppressMenu: true,
      menuTabs: [],
    };

    if (shouldShow) {
      const next = col.hide ? { ...col, hide: false } : col;
      const shown =
        col.flex != null ? { ...next, flex: undefined } : next;
      return { ...shown, ...withoutColumnMenu };
    }
    if (col.hide) return { ...col, ...withoutColumnMenu };
    return { ...col, hide: true, flex: undefined, ...withoutColumnMenu };
  });
}

